import { render, staticRenderFns } from "./travelAgencyDetail.vue?vue&type=template&id=4b1f05d3&scoped=true"
import script from "./travelAgencyDetail.vue?vue&type=script&lang=js"
export * from "./travelAgencyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f05d3",
  null
  
)

export default component.exports